import React, { FC, useMemo, useState } from 'react';
import { Project as ProjectModel } from '@material-bank/projects-api';
import { Stack, StackProps } from '@mui/material';
import { IntlShape } from 'react-intl';

import { ProjectsList } from './ProjectsList';
import { ProjectsListHeader } from './ProjectsListHeader';
import * as styles from './SearchableProjectsList.styles';

interface SearchableProjectsListProps extends StackProps {
  projects: ProjectModel[];
  selectedProjectId?: number | null;
  onProjectButtonClick?(project: ProjectModel): void;
  intl: IntlShape;
}

export const SearchableProjectsList: FC<SearchableProjectsListProps> = (
  props,
) => {
  const {
    projects,
    selectedProjectId,
    onProjectButtonClick,
    intl,
    ...stackProps
  } = props;

  const [searchText, setSearchText] = useState('');

  const filteredProjects = useMemo(() => {
    return projects.filter(
      (project) =>
        project.title.toLowerCase().indexOf(searchText.toLowerCase()) !== -1,
    );
  }, [projects, searchText]);

  return (
    <Stack sx={styles.root} {...stackProps}>
      <ProjectsListHeader
        projectsCount={projects.length}
        searchText={searchText}
        onSearchTextChange={setSearchText}
        intl={intl}
      />
      <ProjectsList
        projects={filteredProjects}
        selectedProjectId={selectedProjectId}
        onProjectButtonClick={onProjectButtonClick}
        intl={intl}
      />
    </Stack>
  );
};
